export const quilEditorOptionsModules = {
    // FIXME: MIKE FIX HET STANDAARD FORMAAT VAN DIE VIDEO
    // TODO: MIKE KIJK HIER: https://github.com/quilljs/quill/issues/1283        toolbar: [[{ 'header': [1, 2, 3, false]}], ['bold', 'italic', 'underline', 'link'], [{ 'list': 'ordered'}, { 'list': 'bullet' }], ['video'], ['clean']],
    // TODO: OF HIER: https://github.com/sky40280/quill-video-resize
    toolbar: [[{ header: [1, 2, 3, false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['video'], ['clean']],
    magicUrl: true,
};
